<template>
  <div>
    <div style="height: 40px; display: flex; align-items: center">
      <div class="work_title_color"></div>
      <span class="work_title"> 门店订单数量统计 </span>
    </div>
    <div style="
        display: flex;
        justify-content: space-around;
        margin-top: 10px;
        width: 100%;
      ">
      <div class="statisticItem">
        <div class="item_img" style="background-color: rgb(0, 255, 255)">
          <img src="@/assets/img/numStatistic.png" />
        </div>
        <div class="item_data">
          <div class="item_Title">加工中</div>
          <div class="item_Num">{{ statisticData.doingCount }}</div>
        </div>
      </div>
      <div class="statisticItem">
        <div class="item_img" style="background-color: rgb(26, 150, 199)">
          <img src="@/assets/img/numStatistic.png" />
        </div>
        <div class="item_data">
          <div class="item_Title">今日订单</div>
          <div class="item_Num">{{ statisticData.todayCount }}</div>
        </div>
      </div>
      <div class="statisticItem">
        <div class="item_img" style="background-color: rgb(202, 69, 69)">
          <img src="@/assets/img/numStatistic.png" />
        </div>
        <div class="item_data">
          <div class="item_Title">近7天订单</div>
          <div class="item_Num">{{ statisticData.sevenCount }}</div>
        </div>
      </div>
      <div class="statisticItem">
        <div class="item_img" style="background-color: rgb(221, 145, 44)">
          <img src="@/assets/img/numStatistic.png" />
        </div>
        <div class="item_data">
          <div class="item_Title">本月订单</div>
          <div class="item_Num">{{ statisticData.monthCount }}</div>
        </div>
      </div>
      <div class="statisticItem">
        <div class="item_img" style="background-color: rgb(30, 214, 61)">
          <img src="@/assets/img/numStatistic.png" />
        </div>
        <div class="item_data">
          <div class="item_Title">本年订单</div>
          <div class="item_Num">{{ statisticData.yearCount }}</div>
        </div>
      </div>
      <div class="statisticItem">
        <div class="item_img" style="background-color: rgb(135, 54, 228)">
          <img src="@/assets/img/numStatistic.png" />
        </div>
        <div class="item_data">
          <div class="item_Title">累计订单</div>
          <div class="item_Num">{{ statisticData.totalCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetStoreOrderNumStatistics } from "@/api/storeOrderApi.js";
export default {
  data() {
    return {
      loading: false,
      statisticData: {
        todayCount: 0,
        sevenCount: 0,
        monthCount: 0,
        yearCount: 0,
        totalCount: 0,
        doingCount: 0,
      },
    };
  },
  components: {},

  created() {
    this.GetStoreOrderNumStatistics();
  },

  mounted() { },

  methods: {
    GetStoreOrderNumStatistics() {
      let param = {};
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let roleList = process.env.VUE_APP_SEE_ALL_DATA;
      if (roleList.includes(userdata.userInfo.deptCode)) {
        param.keyId = userdata.userInfo.deptCode;
      }
      GetStoreOrderNumStatistics(param).then((res) => {
        if (res.code == 1) {
          this.loading = false;
          this.statisticData = res.data;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.work_title_color {
  width: 5px;
  height: 20px;
  background-color: #409eff;
  display: inline-block;
  padding: 0;
  margin: 0;
}

.work_title {
  font-size: 16px;
  font-weight: 700;
  font-family: 微软雅黑;
  padding: 0;
  margin: 0;
  margin-left: 10px;
  display: inline-block;
}

.statisticItem {
  width: 210px;
  height: 100px;
  display: inline-block;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .item_img {
    width: 80px;
    height: 80px;
    border-radius: 10px;
    display: inline-block;

    img {
      width: 60px;
      height: 60px;
      margin: 10px;
    }
  }

  .item_data {
    text-align: center;
    margin-left: 10px;
  }

  .item_Title {
    font-size: 18px;
    font-weight: 600;
    padding-top: 4px;
    color: rgba(7, 6, 6, 0.63);
  }

  .item_Num {
    font-size: 24px;
    font-weight: 600;
    padding-bottom: 4px;
    height: 60px;
    align-content: center;
  }
}
</style>